import { generatePath } from 'react-router-dom';
import { formatDate, IconAttention, Filters, IconConnection } from '@ui/src';
import formatBalance from '../../helpers/format-balance';
import { Transaction, TransactionDescription } from '../types';
import { CardsRoutes } from '../../../routes';

import cn from '../cards.module.css';

const formatTransacationsList = (
  list: Transaction[],
  onFilter: (values: Filters) => void,
  filters: Filters,
  cardId?: string,
  id?: string,
): Transaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    result.date = formatDate(result.date, true);
    result.currency = result.currency.toUpperCase();

    result.url = generatePath(CardsRoutes.CARD_INFO_TRANSACTION_INFO, {
      cardId: cardId as string,
      id: id as string,
      transactionId: result.id,
    });

    const render: Record<string, React.JSX.Element> = {
      orderDetails: (
        <div
          className={`${cn.orderDetailsWrapper} ${
            result.description === TransactionDescription.VOID
              ? cn.canceledTransaction
              : ''
          }`}
          id={result.orderDetails}
        >
          {result.orderDetails}
          <div className={cn.orderDetailsControls}>
            {(result.description === TransactionDescription.CHARGEBACK ||
              result.description === TransactionDescription.REFUND) && (
              <button
                type="button"
                aria-label="Order details filter"
                onClick={() =>
                  onFilter({
                    ...filters,
                    orderDetails: { value: [result.orderDetails] },
                  })
                }
                className={cn.orderDetailsFilterButton}
              >
                <IconConnection />
              </button>
            )}
            <span
              className={`${cn.attentionIconWrapper} ${
                result.description === TransactionDescription.REFUND
                  ? cn.attentionIconWrapperVisible
                  : ''
              }`}
            >
              <IconAttention />
            </span>
          </div>
        </div>
      ),
      amount: (
        <div
          className={`${
            result.description === TransactionDescription.CHARGEBACK ||
            result.description === TransactionDescription.CREDIT
              ? cn.goodTransaction
              : ''
          } ${
            result.description === TransactionDescription.VOID
              ? cn.canceledTransaction
              : ''
          }`}
        >
          {result.fraud && (
            <div className={cn.fraudTransactionIconWrapper}>
              <IconAttention />
            </div>
          )}
          {formatBalance(result.amount)}
        </div>
      ),
    };

    if (
      result.description === TransactionDescription.CHARGEBACK ||
      result.description === TransactionDescription.CREDIT
    ) {
      render.description = (
        <div className={cn.goodTransaction}>{result.description}</div>
      );
      render.amount = (
        <div className={cn.goodTransaction}>{formatBalance(result.amount)}</div>
      );
      render.amountBc = (
        <div className={cn.goodTransaction}>
          {formatBalance(result.amountBc)}
        </div>
      );
    }

    if (result.description === TransactionDescription.VOID) {
      render.date = <div className={cn.canceledTransaction}>{result.date}</div>;
      render.description = (
        <div className={cn.canceledTransaction}>{result.description}</div>
      );
      render.currency = (
        <div className={cn.canceledTransaction}>{result.currency}</div>
      );
      render.amountBc = (
        <div className={cn.canceledTransaction}>
          {formatBalance(result.amountBc)}
        </div>
      );
      render.terminalId = (
        <div className={cn.canceledTransaction}>{result.terminalId}</div>
      );
      render.terminalId = (
        <div className={cn.canceledTransaction}>{result.terminalId}</div>
      );
      render.merchantName = (
        <div className={cn.canceledTransaction}>{result.merchantName}</div>
      );
    }

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatTransacationsList;
